import { createReducer } from '@reduxjs/toolkit'
import { DialogSettings, Dialogs } from 'shared/types'
import * as actions from './actions'

interface State {
  dialog: DialogSettings
  commonDialogs: Dialogs
  bankTransferVerificationDialogOpen: boolean
  lawsuitSignatureDialogOpen: boolean
  uploadFiledLawsuitDialogOpen: boolean
  updateLawsuitDialogOpen: boolean
}

const initialState: State = {
  dialog: {
    isOpen: false,
    title: '',
    text: '',
    image: '',
    type: 'error',
  },
  commonDialogs: {
    lawsuitInstruction: {
      isOpen: false,
    },
    uploadPowerOfAttorney: {
      isOpen: false,
    },
  },
  bankTransferVerificationDialogOpen: false,
  lawsuitSignatureDialogOpen: false,
  uploadFiledLawsuitDialogOpen: false,
  updateLawsuitDialogOpen: false,
}

export default createReducer(initialState, builder =>
  builder
    .addCase(actions.setDialogContent, (state, { payload }) => {
      state.dialog = {
        ...state.dialog,
        ...payload,
      }
    })
    .addCase(actions.toggleDialog, state => {
      state.dialog.isOpen = !state.dialog.isOpen
    })
    .addCase(actions.clearDialog, state => {
      state.dialog = initialState.dialog
    })
    .addCase(actions.setDialogOpenState, (state, { payload }) => {
      state.dialog.isOpen = payload
    })
    .addCase(actions.patchDialogsState, (state, { payload }) => {
      state.commonDialogs = { ...state.commonDialogs, ...payload }
    })
    .addCase(actions.openBankTransferVerificationDialog, state => {
      state.bankTransferVerificationDialogOpen = true
    })
    .addCase(actions.closeBankTransferVerificationDialog, state => {
      state.bankTransferVerificationDialogOpen = false
    })
    .addCase(actions.openLawsuitSignatureDialog, state => {
      state.lawsuitSignatureDialogOpen = true
    })
    .addCase(actions.closeLawsuitSignatureDialog, state => {
      state.lawsuitSignatureDialogOpen = false
    })
    .addCase(actions.openUploadFiledLawsuitDialog, state => {
      state.uploadFiledLawsuitDialogOpen = true
    })
    .addCase(actions.closeUploadFiledLawsuitDialog, state => {
      state.uploadFiledLawsuitDialogOpen = false
    })
    .addCase(actions.openUpdateLawsuitDialog, state => {
      state.updateLawsuitDialogOpen = true
    })
    .addCase(actions.closeUpdateLawsuitDialog, state => {
      state.updateLawsuitDialogOpen = false
    })
)
